import React from "react";
import DOMPurify from "dompurify";
import { useState, useEffect } from "react";
import config from "../config";
import axios from "axios";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Pagination from "../Pagination";
import { useParams } from "react-router-dom";
import nodata from "../image/noData.gif";
import noimage from "../image/noimage.jpg";
import Loader from "../components/Loader";

export default function GymList() {
  const [businessLists, bussinessListState] = useState([]);
  const [businessLenght, setBusinessLength] = useState([]);
  const [seoData, setSeoData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const searchQuery = params.query;
  const cityQuery = params.city;
  const categoryQuery = params.category;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response = await axios.get(
        `${config.apiUrl}/business-list?page=${currentPage}&search=${
          searchQuery ?? ""
        }&category=${categoryQuery ?? ""}&city=${cityQuery ?? ""}`
      );
      bussinessListState(response.data.data);
      setBusinessLength(response.data.meta.total);
      setSeoData(response.data.seo_data);
      setTotalPages(response.data.meta.last_page);
      setLoading(false);
    };

    fetchData();
  }, [currentPage, searchQuery, categoryQuery, cityQuery]);

  useEffect(() => {
    const fetchCity = async () => {
      const response = await axios.get(`${config.apiUrl}/city-list`);
      setCityList(response.data.city_list);
    };

    fetchCity();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const isOpenNow = (openTime, closeTime) => {
    if (!openTime || !closeTime) return null;
    const toMinutes = (t) => {
      const clean = t.replace(/[^0-9:]/g, "").trim();
      const parts = clean.split(":");
      if (parts.length < 2) return null;
      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    };
    const now = new Date();
    const currentMins = now.getHours() * 60 + now.getMinutes();
    const openMins  = toMinutes(openTime);
    const closeMins = toMinutes(closeTime);
    if (openMins === null || closeMins === null) return null;
    if (openMins === 0 && closeMins === 0) return null;
    return currentMins >= openMins && currentMins <= closeMins;
  };

  return (
    <>
      <div className="gym-list-container">
        <HelmetProvider>
          <Helmet>
            {seoData ? (
              <title>{seoData.title}</title>
            ) : (
              <title>
                {`All ${!categoryQuery ? "Gym" : categoryQuery} Centers${cityQuery ? " in " + cityQuery : ""} | MeraGym`}
              </title>
            )}
            <meta
              name="keywords"
              content={
                seoData
                  ? seoData.meta_keyword
                  : "Fitness centers, Gym memberships, Workout centers, Personal trainers, Health and wellness Center, Exercise classes, Cardio workout centers, gyms, meragym, meragym.com, gym near me, gym in my city"
              }
            />
            <meta
              name="description"
              content={
                seoData
                  ? seoData.meta_description
                  : "Explore top fitness centers and gyms near you on Meragym. Find the perfect workout facility to help you achieve your fitness goals. Start your fitness journey today!"
              }
            />
            {seoData && seoData.canonical && (
              <link rel="canonical" href={seoData.canonical} />
            )}
            <meta property="og:title" content={seoData ? seoData.title : `Gyms${cityQuery ? " in " + cityQuery : ""} | MeraGym`} />
            <meta property="og:description" content={seoData ? seoData.meta_description : "Find the best gyms and fitness centers near you on MeraGym."} />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
          </Helmet>
        </HelmetProvider>
        <div className="container mb-3">
          {seoData ? (
            <h1
              className="offHead blog-head"
              style={{ textTransform: "capitalize" }}
            >
              {seoData.main_heading}
            </h1>
          ) : (
            <h1
              className="offHead blog-head"
              style={{ textTransform: "capitalize" }}
            >
              All {!categoryQuery ? "Gym" : categoryQuery} Centers
              {cityQuery ? " In " + cityQuery : ""}
            </h1>
          )}
          <span
            className="text-secondary"
            style={{ textTransform: "capitalize" }}
          >
            {" "}
            Showing {businessLenght} {!categoryQuery ? "Gym" : categoryQuery}{" "}
            Centers {cityQuery ? " In " + cityQuery : ""}
          </span>
          <div className="row g-3 mt-lg-1">
            <div className="col-lg-3 d-lg-block d-none">
              <section className="filter-section">
                <div className="card gym-list-card border-0">
                  <div className="card-body py-2">
                    <h6 className="offHead text-dark pb-2 border-bottom">
                      Filter
                    </h6>

                    {/*Budget Filter */}
                    <button
                      className="btn btn-light w-100 text-start mt-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseCity"
                      aria-expanded="false"
                      aria-controls="collapseCity"
                    >
                      Budget<i className="bi bi-chevron-down loc-down"></i>
                    </button>

                    <div
                      className="collapsible-table collapse"
                      id="collapseCity"
                    >
                      <table className="table m-0">
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Less Than 2000
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  2000-4000
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  4000-6000
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  6000-8000
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  8000 & Above
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/*Fitness Options Filter*/}
                    <button
                      className="btn btn-light w-100 text-start mt-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseGym"
                      aria-expanded="false"
                      aria-controls="collapseGym"
                    >
                      Fitness Options
                      <i className="bi bi-chevron-down loc-down"></i>
                    </button>

                    <div
                      className="collapsible-table collapse"
                      id="collapseGym"
                    >
                      <table className="table m-0">
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  All Fitness Centers
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Gym
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Yoga
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Zumba
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Cross Functional Training
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Dance
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Fitness Studios
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/*Amenities*/}
                    <button
                      className="btn btn-light w-100 text-start mt-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseAmenities"
                      aria-expanded="false"
                      aria-controls="collapseAmenities"
                    >
                      Amenities<i className="bi bi-chevron-down loc-down"></i>
                    </button>

                    <div
                      className="collapsible-table collapse"
                      id="collapseAmenities"
                    >
                      <table className="table m-0">
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  24 Hours Facilities
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Spinning
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Massages
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Personal Training
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Cardio Equipment
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Stretching Area
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Cycling Studio
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/*Gym Loacation*/}
                    <button
                      className="btn btn-light w-100 text-start mt-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseLocation"
                      aria-expanded="false"
                      aria-controls="collapseLocation"
                    >
                      Location<i className="bi bi-chevron-down loc-down"></i>
                    </button>

                    <div
                      className="collapsible-table collapse"
                      id="collapseLocation"
                    >
                      <table className="table m-0">
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Mumbai
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  New Delhi
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Lucknow
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Varanasi
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Pune
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Noida
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  id="flexCheckDefault"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckDefault"
                                >
                                  Banglore
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <button className="btn btn-danger mt-3 w-100">Apply</button>
                  </div>
                </div>
              </section>
            </div>
            <div className="col-12 col-lg-9">
              {loading ? (
                <Loader />
              ) : businessLenght === 0 ? (
                <>
                  <div className="nodata">
                    <img src={nodata} alt="no-data" />
                  </div>
                </>
              ) : (
                <>
                  {businessLists.map((businessData) => {
                    return (
                      <Link
                        to={`/${businessData.slug}`}
                        key={businessData.id}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="card border-0 gym-list-card mt-3 text-dark">
                          <div className="card-body p-2">
                            <div className="row g-2 align-items-center">
                              <div className="col-4 col-sm-4 col-lg-4">
                                <img
                                  src={businessData.thumbnail_image || noimage}
                                  className="gym-list-img rounded-1"
                                  alt={businessData.name}
                                  onError={(e) => { e.target.onerror = null; e.target.src = noimage; }}
                                />
                              </div>
                              <div className="col-8 col-sm-8 col-lg-8">
                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                  <h3 className="gym-name text-dark mt-1 mb-0">
                                    {businessData.name}
                                  </h3>
                                  {(() => {
                                    const open = isOpenNow(businessData.open_time, businessData.close_time);
                                    if (open === null) return null;
                                    return (
                                      <span className={`mg-open-badge ${open ? "mg-open-badge--open" : "mg-open-badge--closed"}`}>
                                        <i className={`bi ${open ? "bi-circle-fill" : "bi-circle"} me-1`}></i>
                                        {open ? "Open" : "Closed"}
                                      </span>
                                    );
                                  })()}
                                </div>
                                <p className="mt-0 card-txt1">
                                  {businessData.area} {businessData.city}
                                  {", "}
                                  {businessData.pincode}
                                </p>
                                <h4 className="text-dark card-txt2">
                                  Available Workouts
                                </h4>
                                <div className="mt-2 mb-2 border-bottom-dashed">
                                  <p className="card-txt1 clip-text">
                                    {businessData.category.map((cat) => {
                                      return (
                                        <span className="me-1" key={cat.id}>
                                          {cat.name},
                                        </span>
                                      );
                                    })}
                                  </p>
                                </div>
                                <div className="row g-3 align-items-center">
                                  <div className="col-12 col-lg-9">
                                    <ul className="ameneties">
                                      {businessData.amenity
                                        .slice(0, 2)
                                        .map((amenity, index) => (
                                          <li key={index}>
                                            {/* <i className="bi bi-wifi"></i> */}
                                            {amenity.name}
                                          </li>
                                        ))}
                                      {businessData.amenity.length - 2 > 0 && (
                                        <li>
                                          +{businessData.amenity.length - 2}{" "}
                                          More
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="text-end">
                                      <button className="btn btn-danger border-0 check-now">
                                        View Gym
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}

                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="footer-desc">
        <div className="container-fluid">
          {seoData ? (
            <>
              {" "}
              <div
                className="desc-content"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(seoData.description || "") }}
              />{" "}
            </>
          ) : (
            ""
          )}
        </div>
        <div className="container-fluid">
          <div className="city-list">
            <h5>Popular Fitness Option</h5>
            <ul>
              {cityList.map((city) => {
                return (
                  <li key={city.city}>
                    <Link to={`/${city.city}/gym`}>
                      {categoryQuery} In {city.city}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
